// client/src/app.jsx
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { lazy, Suspense } from "react";

import LandingDe from "./pages/Lang_Lending/LandingDe.jsx";
import LandingEn from "./pages/Lang_Lending/LandingEn.jsx";
import LandingUk from "./pages/Lang_Lending/LandingUk.jsx";
import LandingFr from "./pages/Lang_Lending/LandingFr.jsx";
import LandingNl from "./pages/Lang_Lending/LandingNl.jsx";
import LandingPl from "./pages/Lang_Lending/LandingPl.jsx";
import LandingIt from "./pages/Lang_Lending/LandingIt.jsx";
import LandingDa from "./pages/Lang_Lending/LandingDa.jsx";
import LandingEs from "./pages/Lang_Lending/LandingEs.jsx";
import LandingNo from "./pages/Lang_Lending/LandingNo.jsx";



const AdminPage = lazy(() => import("./pages/adminPage.jsx"));
const Front = lazy(() => import("./pages/Front.jsx"));

import ScrollToTop from "./components/ScrollToTop.jsx";
import SeoRouteHead from "./components/seo/SeoRouteHead.jsx";


import TermsPage from "./pages/TermsPage.jsx";
import PrivacyPage from "./pages/PrivacyPage.jsx";
import RefundPage from "./pages/RefundPage.jsx";
import ImpressumPage from "./pages/ImpressumPage.jsx";
import PricingPage from "./pages/PricingPage.jsx";

import DemoDe from "./pages/DemoDe.jsx";
import DemoEn from "./pages/DemoEn.jsx";
import DemoNo from "./pages/DemoNo.jsx";

import DigitaleSpeisekarteDe from "./pages/seo/DigitaleSpeisekarteDe.jsx";
import DigitalMenuForRestaurantsEn from "./pages/seo/DigitalMenuForRestaurantsEn.jsx";
import DigitalMenuForRestaurantsNo from "./pages/seo/no_ni/DigitalMenuForRestaurantsNo.jsx";

import QrCodeSpeisekarteDe from "./pages/seo/QrCodeSpeisekarteDe.jsx";
import QrCodeMenuForRestaurantsEn from "./pages/seo/QrCodeMenuForRestaurantsEn.jsx";
import QrCodeMenuForRestaurantsNo from "./pages/seo/no_ni/QrCodeMenuForRestaurantsNo.jsx";

import SpeisekarteMitBildernDe from "./pages/seo/SpeisekarteMitBildernDe.jsx";
import MenuWithPicturesEn from "./pages/seo/MenuWithPicturesEn.jsx";
import MenuWithPicturesNo from "./pages/seo/no_ni/MenuWithPicturesNo.jsx";

import RestaurantQrCodeTischaufstellerDe from "./pages/seo/RestaurantQrCodeTischaufstellerDe.jsx";
import RestaurantQrCodeTableTentEn from "./pages/seo/RestaurantQrCodeTableTentEn.jsx";
import RestaurantQrCodeTableTentNo from "./pages/seo/no_ni/RestaurantQrCodeTableTentNo.jsx";


import MenuTranslationForRestaurantsEn from "./pages/seo/MenuTranslationForRestaurantsEn.jsx";
import SpeisekarteUebersetzenRestaurantDe from "./pages/seo/SpeisekarteUbersetzenRestaurantDe.jsx";
import MenuTranslationForRestaurantsNo from "./pages/seo/no_ni/MenuTranslationForRestaurantsNo.jsx";





import QrCodeSpeisekarteDruckenDe from "./pages/seo/QrCodeSpeisekarteDruckenDe.jsx";
import QrCodeMenuPrintingEn from "./pages/seo/QrCodeMenuPrintingEn.jsx";
import QrCodeMenuPrintingNo from "./pages/seo/no_ni/QrCodeMenuPrintingNo.jsx";

import QrCodeSpeisekarteOhneAppDe from "./pages/seo/QrCodeSpeisekarteOhneAppDe.jsx";
import QrCodeMenuWithoutAppEn from "./pages/seo/QrCodeMenuWithoutAppEn.jsx";
import QrCodeMenuWithoutAppNo from "./pages/seo/no_ni/QrCodeMenuWithoutAppNo.jsx";

import DigitaleSpeisekarteKostenlosTestenDe from "./pages/seo/DigitaleSpeisekarteKostenlosTestenDe.jsx";
import FreeDigitalMenuTestEn from "./pages/seo/FreeDigitalMenuTestEn.jsx";
import FreeDigitalMenuTestNo from "./pages/seo/no_ni/FreeDigitalMenuTestNo.jsx"; 






import SpeisekarteOnlineAendernDe from "./pages/seo/SpeisekarteOnlineAendernDe.jsx";
import ChangeMenuOnlineEn from "./pages/seo/ChangeMenuOnlineEn.jsx";
import ChangeMenuOnlineNo from "./pages/seo/no_ni/ChangeMenuOnlineNo.jsx";







import TageskarteDigitalErstellenDe from "./pages/seo/TageskarteDigitalErstellenDe.jsx";
import CreateDigitalDailyMenuEn from "./pages/seo/CreateDigitalDailyMenuEn.jsx";
import CreateDigitalDailyMenuNo from "./pages/seo/no_ni/CreateDigitalDailyMenuNo.jsx";

import DigitaleGetraenkekarteBarDe from "./pages/seo/DigitaleGetraenkekarteBarDe.jsx";
import DigitalDrinksMenuBarEn from "./pages/seo/DigitalDrinksMenuBarEn.jsx";
import DigitalDrinksMenuBarNo from "./pages/seo/no_ni/DigitalDrinksMenuBarNo.jsx";

import DigitaleSpeisekartePizzeriaDe from "./pages/seo/DigitaleSpeisekartePizzeriaDe.jsx";
import DigitalMenuPizzeriaEn from "./pages/seo/DigitalMenuPizzeriaEn.jsx";
import DigitalMenuPizzeriaNo from "./pages/seo/no_ni/DigitalMenuPizzeriaNo.jsx";


import KostenloseDigitaleSpeisekarteDe from "./pages/seo/KostenloseDigitaleSpeisekarteDe.jsx";
import FreeDigitalMenuForRestaurantsEn from "./pages/seo/FreeDigitalMenuForRestaurantsEn.jsx";
import FreeDigitalMenuForRestaurantsNo from "./pages/seo/no_ni/FreeDigitalMenuForRestaurantsNo.jsx";

import OnlineTischreservierungDe from "./pages/seo/OnlineTischreservierungDe.jsx";
import OnlineTableReservationForRestaurantsEn from "./pages/seo/OnlineTableReservationForRestaurantsEn.jsx";
import OnlineTableReservationForRestaurantsNo from "./pages/seo/no_ni/OnlineTableReservationForRestaurantsNo.jsx";

import RestaurantWebsiteDe from "./pages/seo/RestaurantWebsiteDe.jsx";
import RestaurantWebsiteForRestaurantsEn from "./pages/seo/RestaurantWebsiteForRestaurantsEn.jsx";
import RestaurantWebsiteForRestaurantsNo from "./pages/seo/no_ni/RestaurantWebsiteForRestaurantsNo.jsx";

import DigitalesBestellsystemGastronomieDe from "./pages/seo/DigitalesBestellsystemGastronomieDe.jsx";
import DigitalOrderingSystemForRestaurantsEn from "./pages/seo/DigitalOrderingSystemForRestaurantsEn.jsx";
import DigitalOrderingSystemForRestaurantsNo from "./pages/seo/no_ni/DigitalOrderingSystemForRestaurantsNo.jsx";

import MehrsprachigeSpeisekarteDe from "./pages/seo/MehrsprachigeSpeisekarteDe.jsx";
import MultilingualMenuForRestaurantsEn from "./pages/seo/MultilingualMenuForRestaurantsEn.jsx";
import MultilingualMenuForRestaurantsNo from "./pages/seo/no_ni/MultilingualMenuForRestaurantsNo.jsx";

import SpeisekarteOnlineVerwaltenDe from "./pages/seo/SpeisekarteOnlineVerwaltenDe.jsx";
import ManageMenuOnlineForRestaurantsEn from "./pages/seo/ManageMenuOnlineForRestaurantsEn.jsx";
import ManageMenuOnlineForRestaurantsNo from "./pages/seo/no_ni/ManageMenuOnlineForRestaurantsNo.jsx";

import RestaurantDigitalisierungDe from "./pages/seo/RestaurantDigitalisierungDe.jsx";
import RestaurantDigitalizationEn from "./pages/seo/RestaurantDigitalizationEn.jsx";
import RestaurantDigitalizationNo from "./pages/seo/no_ni/RestaurantDigitalizationNo.jsx";

import DigitaleSpeisekarteVergleichDe from "./pages/seo/DigitaleSpeisekarteVergleichDe.jsx";
import DigitalMenuComparisonEn from "./pages/seo/DigitalMenuComparisonEn.jsx";
import DigitalMenuComparisonNo from "./pages/seo/no_ni/DigitalMenuComparisonNo.jsx";

function detectTenantSubdomain() {
  if (typeof window === "undefined") return null;

  const host = window.location.hostname.toLowerCase();
  const parts = host.split(".");

  if (parts.length <= 2) return null;
  if (parts[0] === "www" && parts.length === 3) return null;

  return parts[0] === "www" ? parts[1] : parts[0];
}

function LegalRoutes() {
  return (
    <>
      <Route path="/:lang/pricing" element={<PricingPage />} />
      <Route path="/:lang/terms" element={<TermsPage />} />
      <Route path="/:lang/privacy" element={<PrivacyPage />} />
      <Route path="/:lang/refund" element={<RefundPage />} />
      <Route path="/:lang/impressum" element={<ImpressumPage />} />

      <Route path="/pricing" element={<Navigate to="/de/pricing" replace />} />
      <Route path="/terms" element={<Navigate to="/de/terms" replace />} />
      <Route path="/privacy" element={<Navigate to="/de/privacy" replace />} />
      <Route path="/refund" element={<Navigate to="/de/refund" replace />} />
      <Route path="/contact" element={<Navigate to="/de/impressum" replace />} />
      <Route path="/impressum" element={<Navigate to="/de/impressum" replace />} />
    </>
  );
}

export default function App() {
  const isTenant = !!detectTenantSubdomain();

  return (
    <BrowserRouter>
    <ScrollToTop />
    <SeoRouteHead />

    <Suspense fallback={<div role="status">Loading...</div>}>
    <Routes>
        {isTenant ? (
          <>
            <Route path="/" element={<Front />} />
            <Route path="/front" element={<Front />} />
            <Route path="/front/:clientId" element={<Front />} />

            <Route path="/menu" element={<Front />} />
            <Route path="/speisekarte" element={<Front />} />
            <Route path="/restaurant-menu" element={<Front />} />

            <Route path="/reservation" element={<Front />} />
            <Route path="/reservierung" element={<Front />} />
            <Route path="/booking" element={<Front />} />
            <Route path="/tables" element={<Front />} />

            <Route path="/admin" element={<AdminPage />} />
            <Route path="/admin/:clientId" element={<AdminPage />} />

            {LegalRoutes()}

            <Route path="/demo" element={<Navigate to="/de/demo" replace />} />
            <Route path="/de/demo" element={<DemoDe />} />
            <Route path="/en/demo" element={<DemoEn />} />
            <Route path="/no/demo" element={<DemoNo />} />

            <Route path="*" element={<Navigate to="/" replace />} />
          </>
        ) : (
          <>
            <Route path="/" element={<Navigate to="/de/" replace />} />

            <Route path="/de" element={<LandingDe />} />
            <Route path="/de/" element={<LandingDe />} />
            <Route path="/en" element={<LandingEn />} />
            <Route path="/en/" element={<LandingEn />} />

            <Route path="/nl/*" element={<LandingNl />} />
            <Route path="/pl/*" element={<LandingPl />} />
            <Route path="/it/*" element={<LandingIt />} />
            <Route path="/da/*" element={<LandingDa />} />
            <Route path="/es/*" element={<LandingEs />} />
            <Route path="/no/*" element={<LandingNo />} />

            <Route path="/de/login" element={<LandingDe />} />
            <Route path="/de/register" element={<LandingDe />} />

            <Route path="/en/login" element={<LandingEn />} />
            <Route path="/en/register" element={<LandingEn />} />

            <Route path="/uk/" element={<LandingUk />} />
            <Route path="/fr/" element={<LandingFr />} />

            <Route path="/uk/register" element={<LandingUk />} />
            <Route path="/fr/register" element={<LandingFr />} />

            <Route path="/uk/login" element={<LandingUk />} />
            <Route path="/fr/login" element={<LandingFr />} />

            <Route path="/login" element={<Navigate to="/de/login" replace />} />
            <Route path="/register" element={<Navigate to="/de/register" replace />} />

            <Route
              path="/de/digitale-speisekarte"
              element={<DigitaleSpeisekarteDe />}
            />
            <Route
              path="/en/digital-menu-for-restaurants"
              element={<DigitalMenuForRestaurantsEn />}
            />

            <Route
              path="/no/digital-meny-for-restauranter"
              element={<DigitalMenuForRestaurantsNo />}
            />

            <Route
              path="/de/qr-code-speisekarte"
              element={<QrCodeSpeisekarteDe />}
            />

            <Route
              path="/de/qr-code-speisekarte-drucken"
              element={<QrCodeSpeisekarteDruckenDe />}
            />

            <Route
              path="/en/qr-code-menu-printing"
              element={<QrCodeMenuPrintingEn />}
            />

            <Route
              path="/no/qr-kode-meny-utskrift"
              element={<QrCodeMenuPrintingNo />}
            />

            <Route
              path="/en/qr-code-menu-for-restaurants"
              element={<QrCodeMenuForRestaurantsEn />}
            />

            <Route
              path="/no/qr-kode-meny-for-restauranter"
              element={<QrCodeMenuForRestaurantsNo />}
            />

            <Route
              path="/de/speisekarte-mit-bildern"
              element={<SpeisekarteMitBildernDe />}
            />
            <Route
              path="/en/menu-with-pictures"
              element={<MenuWithPicturesEn />}
            />

            <Route
              path="/no/meny-med-bilder"
              element={<MenuWithPicturesNo />}
            />

            <Route
              path="/de/kostenlose-digitale-speisekarte"
              element={<KostenloseDigitaleSpeisekarteDe />}
            />
            <Route
              path="/en/free-digital-menu-for-restaurants"
              element={<FreeDigitalMenuForRestaurantsEn />}
            />

            <Route
              path="/no/gratis-digital-meny-for-restauranter"
              element={<FreeDigitalMenuForRestaurantsNo />}
            />

            <Route
              path="/de/online-tischreservierung"
              element={<OnlineTischreservierungDe />}
            />
            <Route
              path="/en/online-table-reservation-for-restaurants"
              element={<OnlineTableReservationForRestaurantsEn />}
            />

            <Route
              path="/no/online-bordreservasjon-for-restauranter"
              element={<OnlineTableReservationForRestaurantsNo />}
            />

            <Route
              path="/de/restaurant-website"
              element={<RestaurantWebsiteDe />}
            />
            <Route
              path="/en/restaurant-website-for-restaurants"
              element={<RestaurantWebsiteForRestaurantsEn />}
            />

            <Route
              path="/no/restaurant-nettside"
              element={<RestaurantWebsiteForRestaurantsNo />}
            />

            <Route
              path="/de/digitales-bestellsystem-gastronomie"
              element={<DigitalesBestellsystemGastronomieDe />}
            />
            <Route
              path="/en/digital-ordering-system-for-restaurants"
              element={<DigitalOrderingSystemForRestaurantsEn />}
            />

            <Route
              path="/no/digitalt-bestillingssystem-for-restauranter"
              element={<DigitalOrderingSystemForRestaurantsNo />}
            />

            <Route
              path="/de/mehrsprachige-speisekarte"
              element={<MehrsprachigeSpeisekarteDe />}
            />
            <Route
              path="/en/multilingual-menu-for-restaurants"
              element={<MultilingualMenuForRestaurantsEn />}
            />

            <Route
                path="/no/flerspraklig-meny-for-restauranter"
                element={<MultilingualMenuForRestaurantsNo />}
              />

            <Route
              path="/en/menu-translation-for-restaurants"
              element={<MenuTranslationForRestaurantsEn />}
            />

            <Route
              path="/no/oversette-restaurantmeny"
              element={<MenuTranslationForRestaurantsNo />}
            />

            <Route
              path="/de/speisekarte-ubersetzen-restaurant"
              element={<SpeisekarteUebersetzenRestaurantDe />}
            />

            <Route
              path="/de/speisekarte-online-verwalten"
              element={<SpeisekarteOnlineVerwaltenDe />}
            />
            <Route
              path="/en/manage-menu-online-for-restaurants"
              element={<ManageMenuOnlineForRestaurantsEn />}
            />

            <Route
              path="/no/administrere-meny-online-for-restauranter"
              element={<ManageMenuOnlineForRestaurantsNo />}
            />

            <Route
              path="/de/restaurant-digitalisierung"
              element={<RestaurantDigitalisierungDe />}
            />
            <Route
              path="/en/restaurant-digitalization"
              element={<RestaurantDigitalizationEn />}
            />

            <Route
              path="/no/restaurant-digitalisering"
              element={<RestaurantDigitalizationNo />}
            />

            <Route
              path="/de/digitale-speisekarte-vergleich"
              element={<DigitaleSpeisekarteVergleichDe />}
            />
            <Route
              path="/en/digital-menu-comparison"
              element={<DigitalMenuComparisonEn />}
            />

            <Route
              path="/no/digital-meny-sammenligning"
              element={<DigitalMenuComparisonNo />}
            />

            <Route
              path="/de/qr-code-speisekarte-ohne-app"
              element={<QrCodeSpeisekarteOhneAppDe />}
            />

            <Route
              path="/en/qr-code-menu-without-app"
              element={<QrCodeMenuWithoutAppEn />}
            />

            <Route
              path="/no/qr-kode-meny-uten-app"
              element={<QrCodeMenuWithoutAppNo />}
            />

            <Route
              path="/de/digitale-speisekarte-kostenlos-testen"
              element={<DigitaleSpeisekarteKostenlosTestenDe />}
            />

            <Route
              path="/en/free-digital-menu-test"
              element={<FreeDigitalMenuTestEn />}
            />

            <Route
              path="/no/test-gratis-digital-meny"
              element={<FreeDigitalMenuTestNo />}
            />

            <Route
              path="/de/speisekarte-online-aendern"
              element={<SpeisekarteOnlineAendernDe />}
            />

            <Route
              path="/en/change-menu-online"
              element={<ChangeMenuOnlineEn />}
            />

            <Route
              path="/no/endre-meny-online"
              element={<ChangeMenuOnlineNo />}
            />

            <Route
              path="/de/tageskarte-digital-erstellen"
              element={<TageskarteDigitalErstellenDe />}
            />

            <Route
              path="/en/create-digital-daily-menu"
              element={<CreateDigitalDailyMenuEn />}
            />

            <Route
                path="/no/opprett-digital-dagsmeny"
                element={<CreateDigitalDailyMenuNo />}
              />

            <Route
              path="/de/digitale-getraenkekarte-bar"
              element={<DigitaleGetraenkekarteBarDe />}
            />

            <Route
              path="/en/digital-drinks-menu-bar"
              element={<DigitalDrinksMenuBarEn />}
            />

            <Route
              path="/no/digital-drikkemeny-bar"
              element={<DigitalDrinksMenuBarNo />}
            />

            <Route
              path="/de/digitale-speisekarte-pizzeria"
              element={<DigitaleSpeisekartePizzeriaDe />}
            />

            <Route
              path="/en/digital-menu-pizzeria"
              element={<DigitalMenuPizzeriaEn />}
            />
            <Route
              path="/no/digital-meny-pizzeria"
              element={<DigitalMenuPizzeriaNo />}
            />

            <Route
              path="/de/restaurant-qr-code-tischaufsteller"
              element={<RestaurantQrCodeTischaufstellerDe />}
            />

            <Route
              path="/en/restaurant-qr-code-table-tent"
              element={<RestaurantQrCodeTableTentEn />}
            />

            <Route
              path="/no/restaurant-qr-kode-bordskilt"
              element={<RestaurantQrCodeTableTentNo />}
            />

            {LegalRoutes()}

            <Route path="/demo" element={<Navigate to="/de/demo" replace />} />
            <Route path="/de/demo" element={<DemoDe />} />
            <Route path="/en/demo" element={<DemoEn />} />
            <Route path="/no/demo" element={<DemoNo />} />

            <Route path="/front/:clientId" element={<Front />} />
            <Route path="/admin/:clientId" element={<AdminPage />} />

            <Route path="/front" element={<Navigate to="/" replace />} />
            <Route path="/admin" element={<Navigate to="/" replace />} />

            <Route path="*" element={<Navigate to="/" replace />} />
          </>
        )}
      </Routes>
    </Suspense>
  </BrowserRouter>
  );
}